/* eslint-disable react/button-has-type */
/* eslint-disable react/no-unknown-property */
import React, { useState } from 'react';

function Pagination({
    currentPage,
    setPage,
    totalPages,
    handlePrev,
    handleNext,
}) {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    return (
        <div className="flex items-center gap-3 font-regular text-[#090909]">
            <p className="text-[12px] md:text-[14px] xl:text-[20px]">Page</p>
            <button
                className={`flex justify-center items-center border border-1 ${
                    currentPage <= 1
                        ? 'bg-[#F5F5F5] border-[#D3D3D3]'
                        : 'border-[#000000]'
                } w-10 sm:w-12 xl:w-16 h-10 sm:h-10 xl:h-16 rounded-full`}
                onClick={handlePrev}
                disabled={currentPage <= 1}
            >
                <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M18.571 6.78613L10.7139 15.0004L18.571 23.2147"
                        stroke={currentPage <= 1 ? '#606060' : '#000000'}
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </button>
            <div className="relative">
                <div
                    className="flex justify-end items-center rounded-full border border-[1px] border-[#000000] h-10 sm:h-12 xl:h-16 w-[80px] sm:w-[96px] xl:w-[120px] px-3 text-[14px] md:text-base xl:text-[24px] cursor-pointer"
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                >
                    <p className="text-center flex-1">{currentPage}</p>
                    <svg
                        className={`transition-transform duration-300 ${
                            isDropdownOpen ? 'rotate-180' : ''
                        }`}
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M4.52344 7.61933L9.99963 12.8574L15.4758 7.61933"
                            stroke="#606060"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </div>
                {isDropdownOpen && (
                    <div className="absolute z-50 -top-[12px] -translate-y-[100%] bg-[#F2F2F2] rounded-3xl border border-[1px] border-[#000000] pl-2 pr-4 py-3 w-full h-auto text-[14px] md:text-base xl:text-[24px]">
                        <div
                            className={`space-y-2 sm:space-y-3 xl:space-y-4 text-center ${
                                totalPages >= 5
                                    ? 'h-[148px] overflow-y-auto scrollbar scrollable'
                                    : 'h-auto'
                            }`}
                        >
                            {Array.from({ length: totalPages }, (_, index) => {
                                const pageNum = index + 1;
                                return (
                                    <div
                                        key={pageNum}
                                        className="cursor-pointer"
                                        style={{ lineHeight: '20px' }}
                                        onClick={() => {
                                            setPage(pageNum);
                                            setIsDropdownOpen(false);
                                        }}
                                    >
                                        {pageNum}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
            </div>

            <button
                className={`flex justify-center items-center border border-[1px] ${
                    currentPage >= totalPages
                        ? 'bg-[#F5F5F5] border-[#D3D3D3]'
                        : 'border-[#000000]'
                } w-10 sm:w-12 xl:w-16 h-10 sm:h-10 xl:h-16 rounded-full`}
                onClick={handleNext}
                disabled={currentPage >= totalPages}
            >
                <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M11.429 23.2139L19.2861 14.9996L11.429 6.78529"
                        stroke={
                            currentPage >= totalPages ? '#D3D3D3' : '#000000'
                        }
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </button>
            <p className="text-[12px] md:text-[14px] xl:text-[20px]">
                of {totalPages}
            </p>
        </div>
    );
}

export default Pagination;
